import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { NotificationsProvider } from 'src/notifications';
import { ApiServiceProvider } from 'src/services/api';
import analyticsClient, { AnalyticsEvent } from 'src/services/analytics';
import App from 'src/App';
import adminAPI from 'src/api/admin-api';
import { LandlordOnboardingProvider } from 'src/pages/landlord/onboard/context';

import 'src/index.css';
import AppStateProvider from 'src/AppStateProvider';
import { ThemeProvider } from 'src/theme';

const checkForOneTimeToken = async () => {
    console.debug('Checking for one time token...');
    const urlParams = new URLSearchParams(window.location.search);
    const oneTimeToken = urlParams.get('oneTimeToken');
    if (oneTimeToken) {
        const res = await adminAPI.getLandlordAuthTokens(oneTimeToken);
        localStorage.setItem('access_token', res.access_token);
        localStorage.setItem('refresh_token', res.refresh_token);
        location.replace('/landlord/inner/messages');
    }
};

checkForOneTimeToken();


// check if we are on the old version of the site
const url = new URL(window.location.href);
if (url.hostname === 'beta.reffie.me') {
    analyticsClient.track(AnalyticsEvent.REDITECTED_FROM_BETA_TO_PLATFORM);
    window.location.replace('https://platform.reffie.me');
}

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <ThemeProvider>
                <NotificationsProvider>
                    <ApiServiceProvider>
                        <AppStateProvider>
                            {/* TODO: Move all state from LandlordOnboardingProvider to AppStateProvider */}
                            <LandlordOnboardingProvider>
                                <App />
                            </LandlordOnboardingProvider>
                        </AppStateProvider>
                    </ApiServiceProvider>
                </NotificationsProvider>
            </ThemeProvider>
        </BrowserRouter>
    </React.StrictMode>
);
